<template>
  <div id="services" class="">
    <div class="text-center flex-grow w-full h-auto mt-12 p-10 pt-0 pb-32">
      <h2 class="absolute font-display text-5xl right-0 left-0 mt-2 md:-mt-8 lg:-mt-5">Services</h2>

      <div
        class="inline-block w-full md:w-10/12 lg:w-7/12 p-0 md:p-4 lg:p-12 mt-32 mb-20 lg:mb-40 text-center h-64 bg-white"
      >
        <div class="flex flex-wrap justify-between items-center">
          <div class="flex-row text-center m-1 md:m-4 lg:md-0">
            <img src="@/assets/img/icons/icon_websites.png" alt="websites">
            <h3 class="font-text text-2xl text-blackish-3">Websites</h3>
          </div>
          <div class="flex-row text-center m-1 md:m-2 lg:md-0">
            <img src="@/assets/img/icons/icon_apps.png" alt="apps">
            <h3 class="font-text text-2xl text-blackish-3">Apps</h3>
          </div>
          <div class="flex-row text-center m-1 md:m-2 lg:md-0">
            <img src="@/assets/img/icons/icon_design.png" alt="design">
            <h3 class="font-text text-2xl text-blackish-3">Design</h3>
          </div>
          <div class="flex-row text-center m-1 md:m-2 lg:md-0">
            <img src="@/assets/img/icons/icon_consulting.png" alt="consulting">
            <h3 class="font-text text-2xl text-blackish-3">Consulting</h3>
          </div>
        </div>
      </div>
    </div>

    <div class="relative w-full z-2 bg-white">
      <img src="@/assets/img/bottom_curve.svg" id="bottom_overhang_img" class="w-full"/>
    </div>
  </div>
</template>

<script>
  import '../../assets/css/index/services.css';

  export default {
    name: 'Services'
  }
</script>
